import { api } from '../../api-helper';
import { URLS } from '../../../constants/URLS';

export const getTaskStatisticsCount = () => {
  return api.get(URLS.getTaskStatistics, {
    headers: {
      needsToken: true
    }
  });
};

export const getProjectNamesList = (searchQuery, clientID, enabled = true) => {
  return api.get(URLS.getProjectNamesList, {
    params: {
      ...(searchQuery && { query: searchQuery }),
      ...(clientID && { clientID: clientID }),
      enabled: enabled
    },

    headers: {
      needsToken: true
    }
  });
};

export const getProjectStatsByName = (projectID) => {
  return api.get(`${URLS.getProjectNamesStats}?id=${projectID}`, {
    headers: {
      needsToken: true
    }
  });
};

export const taskPreviewSortList = () => {
  return api.get(URLS.taskPreviewSortList, {
    headers: {
      needsToken: true
    }
  });
};

export const taskPreviewFilterList = () => {
  return api.get(URLS.taskPreviewFilterList, {
    headers: {
      needsToken: true
    }
  });
};

export const getTaskPreviewAssigneeList = (searchQuery) => {
  return api.get(
    `${URLS.taskPreviewAssigneeList}?${
      searchQuery ? `query=${searchQuery}` : ''
    }`,
    {
      headers: {
        needsToken: true
      }
    }
  );
};

export const getFlowOrderDetails = () => {
  return api.get(URLS.getTaskCompleted, { headers: { needsToken: true } });
};

export const getTaskPreviewDashbaord = (searchQuery, bodydata, page, limit) => {
  return api.post(URLS.dashboardTasks, bodydata, {
    params: {
      ...(searchQuery && { query: searchQuery }),
      ...(page && { page: page }),
      ...(limit && { limit: limit })
    },
    headers: { needsToken: true }
  });
};
